import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <ContactSection />
        <AboutSection />
        <UpdatesSection />
        <TopicsSection />
        <AppSection />
        <FaqSection />
        <CarouselSection />
        <CardsSection />
        <FeaturesSection />
        <IndexSection />
        <RankingSection />
        <CommentsSection />
        <MediaSection />
      </main>

      <Footer />
    </div>
  );
}